import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../../diccionarios/empModulo';
import { PuntoEntregaModel } from '../../models/puntoEntregaModel';
import { CaracteristicaModel } from '../../models/caracteristicaModel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaracionesService {

  diccionarioUrl: any;
  urlNomina: string;
  diccionarioUrl_pe: any;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlNomina = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.epp.administrador;
    this.diccionarioUrl_pe = empModulo.url.epp.puntoEntrega;
  }

  


  //Empleados
  findEmpleados(cedula:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.findEmpleadoValidar+"/"+cedula );
  }

  //obtenerProvincias
  getAllProvincias(){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.getProvincias);
  }

  getUsuariosMarcaciones(){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.getUsuarioMarcacion);
  }

  getCreateUsuariosMarcaciones(cedula:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.getUsuarioMarcacion+'/create/'+cedula);
  }

  deleteUsuarioMaracion(cedula:string){
    return this.commom.peticionDeleteConHeader(this.urlNomina+this.diccionarioUrl.getUsuarioMarcacion+'/'+cedula);
  }

  getAllEmpresas() {//: Observable<DatosColaboradores> {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getEmpresas);
  }

  getAllEmpresaSolicita() {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getEmpresaSolicita);
  }

  getAllEmpleadoEmpresa(empresa: string){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.empleadoEmpresa + empresa);
  }

  findEmpleadosCedula(cedula:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.findEmpleado + "/"+cedula );
  }

}